import React, { Component } from "react"
import { Section, H2, Content, Space, Visible } from "AtomicComponents"
import { Heading, ArticlePreview, FullWidthImageSection, CardYoutubePlayerList, Tabs } from "AtomicContainers"
import { ArticleHeader } from "AtomicContainers/ArticlePage/ArticlePage"

const ALL_FILTER = "All stories"

class ArticleSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.components,
      activeIndex: 0,
      categoryFilters: [{
        name: ALL_FILTER
      }]
    }
  }


  componentDidMount() {
    const { components } = this.props
    const items = components
      ? components.filter(i => i.name === "ArticlePreview").map(i => i.props)
      : []

    const catgoriesInProps = {}
    items.forEach((i) => {
      i.categories.forEach((s) => {
        catgoriesInProps[s] = true
      })
    })

    this.setState({
      items,
      categoryFilters: [
        ...Object.keys(catgoriesInProps).map(name => ({ name: name })),
        { name: ALL_FILTER }
      ]
    })
  }

  handleChangeCategoryFilter = (index) => {
    this.setState({ activeIndex: index })
  }

  itemMatching = (item) => {
    const { activeIndex, categoryFilters } = this.state

    return (
      activeIndex === (categoryFilters.length - 1) ||
      item.categories && item.categories.indexOf(categoryFilters[activeIndex].name) !== -1
    )
  }

  render() {
    const { title, summary, hero, backButton } = this.props
    const { items, categoryFilters, activeIndex } = this.state
    const filteredData = items.filter(this.itemMatching)
    const featuredFilteredData = filteredData.filter(item => !!item.featured)
    const nonFeaturedFilteredData = filteredData.filter(item => !item.featured)
    const filteredHero = hero && hero.length && hero.filter(item => categoryFilters[activeIndex] && item.category === categoryFilters[activeIndex].name)

    return (
      <div>
        {backButton && <ArticleHeader backUrl={backButton.href} backText={backButton.name} />}
        <Section padding>
          <H2 withDetails>{title}</H2>
          <Content>{summary}</Content>
          <Space />
          <Space />
          {
            categoryFilters &&
            categoryFilters.length > 2 &&
            <Tabs
              onClick={this.handleChangeCategoryFilter}
              activeIndex={activeIndex}
              animatedLine
              dropdown
              options={categoryFilters} />
          }
          {
            categoryFilters &&
            categoryFilters.length > 2 &&
            <Space />
          }
          {
            filteredHero &&
            filteredHero.length ?
            filteredHero.map((item, index) => (
              <Section gutter={true} key={`ArticleSelectorHero-${index}`}>
                <Space />
                <Visible visible={["screen"]}>
                  <FullWidthImageSection
                    backgroundImage={item.imageUrl}
                    height="medium"
                    align="center"
                    textAlign="center">
                    <Heading
                      white
                      tag="h4"
                      value={item.heading}
                      preHeading={item.preHeading} />
                  </FullWidthImageSection>
                </Visible>
                <Visible visible={["tablet"]}>
                  <FullWidthImageSection
                    backgroundImage={item.imageUrl}
                    height="tall"
                    align="center"
                    textAlign="center">
                    <Heading
                      white
                      tag="h4"
                      value={item.heading}
                      preHeading={item.preHeading} />
                  </FullWidthImageSection>
                </Visible>
                <Visible visible={["mobile"]}>
                  <FullWidthImageSection
                    backgroundImage={item.imageUrl}
                    height="widescreen"
                    align="center"
                    textAlign="center">
                    <Heading
                      white
                      tag="h4"
                      value={item.heading}
                      preHeading={item.preHeading} />
                  </FullWidthImageSection>
                </Visible>
              </Section>
            ))
            : null
          }
          {
            activeIndex !== (categoryFilters.length - 1) &&
            featuredFilteredData &&
            featuredFilteredData.length ?
            <CardYoutubePlayerList
              numberOfColumns={4}
              showCounting={false}
            >
              {featuredFilteredData.map((item, index) => <ArticlePreview {...item} key={`ArticlePreviewFeatured-${index}`} />)}
            </CardYoutubePlayerList>
            : null
          }
          {
            nonFeaturedFilteredData &&
            nonFeaturedFilteredData.length ?
            <CardYoutubePlayerList
              numberOfColumns={4}
              showCounting={false}
            >
              {nonFeaturedFilteredData.map((item, index) => <ArticlePreview {...item} key={`ArticlePreview-${index}`} />)}
            </CardYoutubePlayerList>
            : null
          }
        </Section>
      </div>
    )
  }
}

export default ArticleSelector



// WEBPACK FOOTER //
// ./src/AtomicContainers/ArticleSelector/ArticleSelector.jsx